import * as React from 'react';
import { Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

function DefaultHeader(_ref) {
  var logoUrl = _ref.logoUrl,
      onNavigate = _ref.onNavigate;
  return React.createElement(React.Fragment, null, React.createElement(Image, {
    src: logoUrl ? logoUrl : '/src/assets/images/logos/rmr_live_logo_0,25x.png',
    as: Link,
    to: '/',
    className: 'nav-menu__logo-link',
    onClick: onNavigate
  }));
}

export default DefaultHeader;